// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"e92f99e7","44":"04f49f58","195":"e4a60ff6","367":"e4a60ff6","750":"e4a60ff6"}[chunkId] + ".chunk.css";
};